import styled from '@emotion/styled';
import { Link as MaterialUILink } from '@mui/material';

export const Link = styled(MaterialUILink)``;

export const StyledTermsAndPolicy = styled.div`
  margin: 0 5.1538rem;
  display: flex;
  flex-direction: row;
  gap: 0.3077rem;
`;
